module.exports = __webpack_public_path__ + "img/cadeado.e61777bd.svg";